// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import Dialog from 'presentations/views/components/atoms/Dialog';
import { Props } from './types';
import CancelRasonList from './components/CancelReasonList';
import FeedbackTextarea from './components/FeedbackTextarea';
import Confirm from './components/Confirm';
import Stepper from 'presentations/views/components/atoms/Stepper';
import DialogSubmitField from 'presentations/views/components/molecules/DialogSubmitField';
import { fontSize, fontWeight, spacing } from 'presentations/views/styles';
import { useCancelQuestionDialog } from './hooks';
import { gray04 } from 'presentations/views/styles/color';

export default function CancelQuestionDialog(props: Props) {
  const t = translateInComponent(translations);
  const { state, actions } = useCancelQuestionDialog(props);

  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={props.onCancel}
      scroll
      titleComponent={
        <StyledTitleContainer>
          <StyledTitle>{t('title')}</StyledTitle>
          <StyledDesc>{t('description')}</StyledDesc>
          <StyledBorder />
        </StyledTitleContainer>
      }
      actions={
        <DialogSubmitField
          isLoading={props.isLoading}
          isDisabled={!state.canNextStep}
          onSubmit={actions.onClickNext}
          onCancel={actions.onClickBack}
          submitLabel={t(state.submitText)}
          cancelLabel={t(state.cancelText)}
        />
      }
    >
      <StyledStepper
        steps={['1', '2', '3']}
        activeStep={state.currentStep}
        isHideLabel
      />
      {state.isShowConfirmLeaveText ? (
        <StyledStep>{t(`questionLeave`)}</StyledStep>
      ) : (
        <StyledStep>
          {t(`question${state.currentStep}`, { plan: 'Free' })}
        </StyledStep>
      )}
      {state.currentStep === 0 && (
        <CancelRasonList
          value={state.cancelReasonTypes}
          onChange={actions.onChange}
          askForDetailCancelReason={state.askForDetailCancelReason}
          askForDetail={state.askForDetail}
          onChangeAskForDetail={actions.onChange}
        />
      )}
      {state.currentStep === 1 && (
        <FeedbackTextarea value={state.feedback} onChange={actions.onChange} />
      )}
      {state.currentStep === 2 && !props.isLeave && (
        <Confirm planName={props.planName} endedAt={props.endedAt} />
      )}
    </Dialog>
  );
}

const StyledTitleContainer = styled.div`
  font-weight: ${fontWeight('normal')};
`;
const StyledTitle = styled.div`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(20)};
  margin-bottom: ${spacing(16)};
  text-align: left;
  white-space: pre-wrap;
`;
const StyledDesc = styled.div`
  font-size: ${fontSize(14)};
  text-align: left;
  white-space: pre-wrap;
  margin: ${spacing(24)} 0;
`;
const StyledBorder = styled.div`
  border: 1px solid ${gray04};
`;
const StyledStep = styled.div`
  font-size: ${fontSize(16)};
  margin-top: ${spacing(16)};
  margin-bottom: ${spacing(8)};
  font-weight: ${fontWeight('bold')};
`;
const StyledStepper = styled(Stepper)`
  padding: ${spacing(24)} 0;
`;
